export interface PurchaseBillRecord {
  id: string;
  billType: 'PO' | 'GRN';
  number: string;
  date: string;
  vendorName: string;
  vendorId: string;
  amount: number;
  itemCount: number;
  referenceId: string;
  createdAt: string;
}

let bills: PurchaseBillRecord[] = [];
let listeners: (() => void)[] = [];

function notify() {
  listeners.forEach((fn) => fn());
}

export function getPurchaseBills() {
  return bills;
}

export function addPurchaseBill(bill: PurchaseBillRecord) {
  bills = [bill, ...bills];
  notify();
}

export function removePurchaseBill(id: string) {
  bills = bills.filter((b) => b.id !== id);
  notify();
}

export function subscribePurchaseBills(fn: () => void) {
  listeners.push(fn);
  return () => {
    listeners = listeners.filter((l) => l !== fn);
  };
}